var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 0.1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    strokeWidth: 1.6,
    d: "M43.643992,7 L49.4370907,7 L44.3601676,18 L10.5972941,18 L5.67421716,8.85714286 L41.4119674,8.85714286 L43.643992,7 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "stroke",
    strokeWidth: 1.6,
    x: 20,
    y: 4,
    width: 9,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "stroke",
    strokeWidth: 1.6,
    x: 29,
    y: 4,
    width: 9,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M14.9994435,12 C14.4474124,12 14,12.4485253 14,12.9994435 C14,13.5514747 14.4474124,14 14.9994435,14 C15.5514747,14 15.998887,13.5514747 15.998887,12.9994435 C15.998887,12.4485253 15.5514747,12 14.9994435,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M21.9994435,12 C21.4474124,12 21,12.4485253 21,12.9994435 C21,13.5514747 21.4474124,14 21.9994435,14 C22.5514747,14 22.998887,13.5514747 22.998887,12.9994435 C22.998887,12.4485253 22.5514747,12 21.9994435,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M28.9994435,12 C28.4474124,12 28,12.4485253 28,12.9994435 C28,13.5514747 28.4474124,14 28.9994435,14 C29.5514747,14 29.998887,13.5514747 29.998887,12.9994435 C29.998887,12.4485253 29.5514747,12 28.9994435,12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "stroke",
    strokeWidth: 1.6,
    x: 11,
    y: 4,
    width: 9,
    height: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.93ad73428f1b459c9d6e53e31fa2ffa1.svg";
export { ForwardRef as ReactComponent };